import styled from "styled-components";

const ExpandedContentSectionContent = styled.div`
    padding: 0.5rem 1.5rem;
`;

export { ExpandedContentSectionContent };
